function onReady(yourMethod) {
  if (document.readyState === 'complete') { 
    setTimeout(yourMethod, 1); 
  }
  else {
    readyStateCheckInterval = setInterval(function() {
      if (document.readyState === 'complete') { 
        clearInterval(readyStateCheckInterval);
        yourMethod();
      }
    }, 10);
  }
}

onReady(function(){
	var first_prdcthndle = "triple-aero-pro-max-42371519086669";
	var second_prdcthndle = "triple-boost-pro-gen2-41989453545549";
	var third_prdcthndle = "dual-boost-15-6-pro-max-gen4-42402394832973";
	

	
	document.getElementsByClassName("spec_detail")[0].classList.remove("hide");
	
    document.getElementsByClassName("ad-comp-prdctimg-one " + first_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad-comp-prdctimg-bttom-one " + first_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_highlights_one " + first_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_monitor_type_one " + first_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_product_color_one " + first_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_materials_one " + first_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_laptop_match_one " + first_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_software_required_one " + first_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_software_link_one " + first_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_software_version_one " + first_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_user_manual_link_one " + first_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_power_delivery_one " + first_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_reverse_charging_one " + first_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_vesa_system_one " + first_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_speakers_one " + first_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_product_size_unfolded_one " + first_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_product_size_folded_one " + first_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_product_weight_one " + first_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_built_in_battery_one " + first_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_included_in_the_box_one " + first_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_certifications_one " + first_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_display_size_one " + first_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_display_type_one " + first_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_resolution_2_one " + first_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_brightness_one " + first_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_contrast_one " + first_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_colors_one " + first_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_refresh_rate_one " + first_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_aspect_ratio_one " + first_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_eye_care_mode_one " + first_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_visual_angle_one " + first_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_product_configuration_one " + first_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_modes_one " + first_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_auto_sensing_one " + first_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_operating_systems_one " + first_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_apple_processors_one " + first_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_macos_versions_one " + first_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_windows_versions_one " + first_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_android_versions_one " + first_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_linux_versions_one " + first_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_game_consoles_one " + first_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_inputs_one " + first_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_osd_menu_one " + first_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_buttons_one " + first_prdcthndle)[0].classList.remove("hide");
	
	
    document.getElementsByClassName("ad-comp-prdctimg-two " + second_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad-comp-prdctimg-bttom-two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_highlights_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_monitor_type_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_product_color_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_materials_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_laptop_match_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_software_required_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_software_link_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_software_version_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_user_manual_link_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_power_delivery_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_reverse_charging_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_vesa_system_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_speakers_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_product_size_unfolded_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_product_size_folded_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_product_weight_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_built_in_battery_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_included_in_the_box_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_certifications_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_display_size_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_display_type_two " + second_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_resolution_2_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_brightness_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_contrast_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_colors_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_refresh_rate_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_aspect_ratio_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_eye_care_mode_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_visual_angle_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_product_configuration_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_modes_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_auto_sensing_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_operating_systems_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_apple_processors_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_macos_versions_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_windows_versions_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_android_versions_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_linux_versions_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_game_consoles_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_inputs_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_osd_menu_two " + second_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_buttons_two " + second_prdcthndle)[0].classList.remove("hide");
    
	
    document.getElementsByClassName("ad-comp-prdctimg-three " + third_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad-comp-prdctimg-bttom-three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_highlights_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_monitor_type_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_product_color_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_materials_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_laptop_match_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_software_required_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_software_link_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_software_version_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_user_manual_link_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_power_delivery_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_reverse_charging_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_vesa_system_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_speakers_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_product_size_unfolded_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_product_size_folded_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_product_weight_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_built_in_battery_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_included_in_the_box_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_certifications_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_display_size_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_display_type_three " + third_prdcthndle)[0].classList.remove("hide");
	document.getElementsByClassName("ad_resolution_2_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_brightness_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_contrast_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_colors_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_refresh_rate_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_aspect_ratio_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_eye_care_mode_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_visual_angle_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_product_configuration_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_modes_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_auto_sensing_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_operating_systems_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_apple_processors_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_macos_versions_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_windows_versions_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_android_versions_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_linux_versions_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_game_consoles_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_inputs_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_osd_menu_three " + third_prdcthndle)[0].classList.remove("hide");
    document.getElementsByClassName("ad_buttons_three " + third_prdcthndle)[0].classList.remove("hide");
    
});

function prdctslctn_one(hndle) {
    document.getElementsByClassName("spec_detail")[0].classList.remove("hide");
  
    var prdcthndle = hndle.value;
	
    document.querySelectorAll(".ad-comp-prdctimg-bttom-one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad-comp-prdctimg-bttom-one " + prdcthndle)[0].classList.remove("hide");
	
	document.querySelectorAll(".ad-comp-prdctimg-one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad-comp-prdctimg-one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_highlights_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_highlights_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_monitor_type_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_monitor_type_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_product_color_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_product_color_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_materials_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_materials_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_laptop_match_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_laptop_match_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_software_required_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_software_required_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_software_link_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_software_link_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_software_version_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_software_version_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_user_manual_link_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_user_manual_link_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_power_delivery_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_power_delivery_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_reverse_charging_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_reverse_charging_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_vesa_system_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_vesa_system_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_speakers_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_speakers_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_product_size_unfolded_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_product_size_unfolded_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_product_size_folded_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_product_size_folded_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_product_weight_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_product_weight_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_built_in_battery_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_built_in_battery_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_included_in_the_box_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_included_in_the_box_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_certifications_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_certifications_one " + prdcthndle)[0].classList.remove("hide");
	
	document.querySelectorAll(".ad_display_size_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_display_size_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_display_type_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_display_type_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_resolution_2_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_resolution_2_one " + prdcthndle)[0].classList.remove("hide");
	
	document.querySelectorAll(".ad_brightness_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_brightness_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_contrast_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_contrast_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_colors_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_colors_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_refresh_rate_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_refresh_rate_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_aspect_ratio_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_aspect_ratio_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_eye_care_mode_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_eye_care_mode_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_visual_angle_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_visual_angle_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_product_configuration_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_product_configuration_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_modes_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_modes_one " + prdcthndle)[0].classList.remove("hide");
	
	document.querySelectorAll(".ad_auto_sensing_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_auto_sensing_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_operating_systems_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_operating_systems_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_apple_processors_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_apple_processors_one " + prdcthndle)[0].classList.remove("hide");
	
	document.querySelectorAll(".ad_macos_versions_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_macos_versions_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_windows_versions_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_windows_versions_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_android_versions_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_android_versions_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_linux_versions_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_linux_versions_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_game_consoles_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_game_consoles_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_inputs_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_inputs_one " + prdcthndle)[0].classList.remove("hide");
	

    document.querySelectorAll(".ad_osd_menu_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_osd_menu_one " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_buttons_one").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_buttons_one " + prdcthndle)[0].classList.remove("hide");
	
}

function prdctslctn_two(hndle) {
    document.getElementsByClassName("spec_detail")[0].classList.remove("hide");
    
    var prdcthndle = hndle.value;
    
	document.querySelectorAll(".ad-comp-prdctimg-two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad-comp-prdctimg-two " + prdcthndle)[0].classList.remove("hide");
	
	document.querySelectorAll(".ad-comp-prdctimg-bttom-two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad-comp-prdctimg-bttom-two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_highlights_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_highlights_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_monitor_type_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_monitor_type_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_product_color_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_product_color_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_materials_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_materials_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_laptop_match_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_laptop_match_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_software_required_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_software_required_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_software_link_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_software_link_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_software_version_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_software_version_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_user_manual_link_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_user_manual_link_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_power_delivery_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_power_delivery_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_reverse_charging_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_reverse_charging_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_vesa_system_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_vesa_system_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_speakers_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_speakers_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_product_size_unfolded_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_product_size_unfolded_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_product_size_folded_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_product_size_folded_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_product_weight_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_product_weight_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_built_in_battery_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_built_in_battery_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_included_in_the_box_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_included_in_the_box_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_certifications_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_certifications_two " + prdcthndle)[0].classList.remove("hide");
	
	document.querySelectorAll(".ad_display_size_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_display_size_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_display_type_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_display_type_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_resolution_2_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_resolution_2_two " + prdcthndle)[0].classList.remove("hide");
	
	document.querySelectorAll(".ad_brightness_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_brightness_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_contrast_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_contrast_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_colors_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_colors_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_refresh_rate_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_refresh_rate_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_aspect_ratio_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_aspect_ratio_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_eye_care_mode_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_eye_care_mode_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_visual_angle_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_visual_angle_two " + prdcthndle)[0].classList.remove("hide");
	
	document.querySelectorAll(".ad_product_configuration_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_product_configuration_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_modes_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_modes_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_auto_sensing_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_auto_sensing_two " + prdcthndle)[0].classList.remove("hide");
	
	document.querySelectorAll(".ad_operating_systems_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_operating_systems_two " + prdcthndle)[0].classList.remove("hide");
	
	document.querySelectorAll(".ad_apple_processors_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_apple_processors_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_macos_versions_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_macos_versions_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_windows_versions_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_windows_versions_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_android_versions_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_android_versions_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_linux_versions_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_linux_versions_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_game_consoles_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_game_consoles_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_inputs_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_inputs_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_osd_menu_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_osd_menu_two " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_buttons_two").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_buttons_two " + prdcthndle)[0].classList.remove("hide");

}

function prdctslctn_three(hndle) {
    document.getElementsByClassName("spec_detail")[0].classList.remove("hide");
    
    var prdcthndle = hndle.value;
    
	document.querySelectorAll(".ad-comp-prdctimg-three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad-comp-prdctimg-three " + prdcthndle)[0].classList.remove("hide");
	
	document.querySelectorAll(".ad-comp-prdctimg-bttom-three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad-comp-prdctimg-bttom-three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_highlights_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_highlights_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_monitor_type_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_monitor_type_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_product_color_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_product_color_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_materials_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_materials_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_laptop_match_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_laptop_match_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_software_required_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_software_required_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_software_link_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_software_link_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_software_version_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_software_version_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_user_manual_link_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_user_manual_link_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_power_delivery_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_power_delivery_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_reverse_charging_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_reverse_charging_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_vesa_system_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_vesa_system_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_speakers_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_speakers_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_product_size_unfolded_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_product_size_unfolded_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_product_size_folded_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_product_size_folded_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_product_weight_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_product_weight_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_built_in_battery_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_built_in_battery_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_included_in_the_box_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_included_in_the_box_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_certifications_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_certifications_three " + prdcthndle)[0].classList.remove("hide");
	
	document.querySelectorAll(".ad_display_size_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_display_size_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_display_type_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_display_type_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_resolution_2_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_resolution_2_three " + prdcthndle)[0].classList.remove("hide");
	
	document.querySelectorAll(".ad_brightness_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_brightness_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_contrast_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_contrast_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_colors_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_colors_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_refresh_rate_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_refresh_rate_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_aspect_ratio_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_aspect_ratio_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_eye_care_mode_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_eye_care_mode_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_visual_angle_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_visual_angle_three " + prdcthndle)[0].classList.remove("hide");
	
	document.querySelectorAll(".ad_product_configuration_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_product_configuration_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_modes_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_modes_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_auto_sensing_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_auto_sensing_three " + prdcthndle)[0].classList.remove("hide");
	
	document.querySelectorAll(".ad_operating_systems_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_operating_systems_three " + prdcthndle)[0].classList.remove("hide");
	
	document.querySelectorAll(".ad_apple_processors_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_apple_processors_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_macos_versions_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_macos_versions_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_windows_versions_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_windows_versions_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_android_versions_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_android_versions_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_linux_versions_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_linux_versions_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_game_consoles_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_game_consoles_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_inputs_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_inputs_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_osd_menu_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_osd_menu_three " + prdcthndle)[0].classList.remove("hide");

    document.querySelectorAll(".ad_buttons_three").forEach((element) => element.classList.add("hide"));
    document.getElementsByClassName("ad_buttons_three " + prdcthndle)[0].classList.remove("hide");
}